import { type QueryHookOptions, useQuery } from "@apollo/client";
import { StorageBreakdownQuery } from "../graphql/queries";
import type {
  StorageBreakdownQueryType,
  StorageBreakdownQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useStorageBreakdownQuery = (
  options?: QueryHookOptions<
    StorageBreakdownQueryType,
    StorageBreakdownQueryVariablesType
  >
) => {
  return useQuery<
    StorageBreakdownQueryType,
    StorageBreakdownQueryVariablesType
  >(StorageBreakdownQuery, { fetchPolicy: "cache-and-network", ...options });
};
